module.exports = __webpack_public_path__ + "static/media/roomsphere.c9e3476b.glb";